module.exports = __webpack_public_path__ + "img/vessel_corona_citrus.ff3989a1.jpg";